import React from "react";

import Typography from "@material-ui/core/Typography";

import useStyles from "./css";
import { UserServiceCategoryProps } from "./props";
import SwitchWithLabel from "../../../../common/SwitchWithLabel";
import UserServiceCertifications from "../UserServiceCertifications";
import { UserServiceCertificationGroup } from "../../../../../models/user-service-certification-group";
import { UserService } from "../../../../../models/user-service";


export default function UserServiceCategory(props: UserServiceCategoryProps) {

  const { userId, serviceCategory, setServiceCategory, handleS3ImageSave } = props;
  
  const classes = useStyles();
  
  const renderServiceItems = (service: UserService, index: number) => {
    
    const setServices = (value: boolean) => {
      const newServices = serviceCategory.services;
      newServices[index].value = value;
      setServiceCategory({...serviceCategory, services: newServices });
    }

    const certifications: UserServiceCertificationGroup = {
      serviceId: service.id,
      userId: userId,
      certifications: serviceCategory.services.find(s => s.id === service.id)?.certifications ?? []
    };

    const setCertifications = (value: UserServiceCertificationGroup) => {
      const newServices = serviceCategory.services;
      newServices[index].certifications = value.certifications;
      setServiceCategory({ ...serviceCategory, services: newServices });
    };

    return (
      <div className={classes.serviceItem} key={service.id}>
        <SwitchWithLabel
          value={service.value}
          setValue={setServices}
          label={service.name}
        />
        {service.value &&
          <UserServiceCertifications
            certifications={certifications}
            setCertifications={setCertifications}
            handleS3ImageSave={handleS3ImageSave}
          />
        }
      </div>
    );
  }
  
  return (
    <div key={serviceCategory.id}>
      <Typography className={classes.header}>{serviceCategory.name}</Typography>
      <div className={classes.servicesContainer}>
        {serviceCategory.services.map(renderServiceItems)}
      </div>
      <div className={classes.divider} />
    </div>
  );
}